/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import classNames from "classnames";
import Button from "components/Buttons/ThemeButton";
import { getClassNameVariant } from "components/DIP/helper";
import { getFlexBasis } from "components/DIP/lib/helper";
import { useStickyDIPAction } from "components/StickyDIP/hooks/useStickyDipAction";
import { useEnvContext } from "contexts";
import { IShopPurchaseOffer } from "contexts/WebStoreProvider/types";
import { FeaturesFlags } from "helpers";
import { useAppSelector } from "hooks";
import { DipButton } from "interfaces";
import { selectWebStoreState } from "redux/slices";
// import { CardFinalMessage } from "styles/general_styles";
import { CrossedOutText } from "styles/general_styles";
import { getDisplayRewards } from "helpers/getDisplayRewards";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";
import { sortBundleRewards } from "helpers/rewardSort";

import {
	CustomLoyaltyPointsV2,
	Footer,
	ItemImage,
	Items,
	LoyaltyPoints,
	LoyaltyValue,
	OfferItem,
	OffersStyled,
	RewardAmount,
	RewardItem
} from "./styles";

interface OffersProps {
	data: Omit<
		IShopPurchaseOffer,
		"onlyNonPayers" | "priority" | "purchaseButtonBannerText" | "bannerText"
	>[];
}

export const Offers: React.FC<OffersProps> = ({ data }: OffersProps) => {
	const isLowWidth = useMediaQuery("(max-width:733px)");
	const isMobile = isLowWidth;
	const { rewards, rewardTypes } = useAppSelector(selectWebStoreState).store;
	const { isFeatureFlagEnabled } = useEnvContext();
	const { onStickyAction } = useStickyDIPAction();
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty messaging.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	const arrayTest = [1, 2, 3, 4, 5, 6, 7, 8];

	return (
		<OffersStyled className={getClassNameVariant(data?.length as number)}>
			{data &&
				data.map(
					(
						{ rewardId, price, loyaltyPointReward, id, loyaltyPointCrossout },
						key
					) => {
						const items = getDisplayRewards(rewardId, {
							rewards,
							rewardTypes
						});
						return (
							<OfferItem
								key={key}
								className={classNames([
									getClassNameVariant(data.length as number),
									loyaltyPointReward && "loyalty-reward",
									"item-reward"
								])}
							>
								<Items
									className={classNames([
										getClassNameVariant(data.length as number),
										"bundle-rewards-item"
									])}
								>
									{/* {arrayTest.map(({}, key) => {
										const flexBasis = getFlexBasis(
											data as unknown as DipButton[],
											arrayTest,
											isMobile
										);

										return (
											<RewardItem key={key} width={flexBasis + "%"}>
												<ItemImage
													src={
														"https://cdn.solitairetripeaks.com/WebStore/reward_images/coin.png"
													}
													alt=""
												/>

												<RewardAmount>{200}</RewardAmount>
											</RewardItem>
										);
									})} */}

									{sortBundleRewards(items).map(
										({ imageUrl, description }, key) => {
											const flexBasis = getFlexBasis(
												data as unknown as DipButton[],
												items,
												isMobile
											);

											return (
												<RewardItem key={key} width={flexBasis + "%"}>
													<ItemImage src={imageUrl} alt="" />
													<RewardAmount className="description">
														{description}
													</RewardAmount>
												</RewardItem>
											);
										}
									)}
								</Items>

								<Footer
									className={classNames([
										loyaltyPointReward && "loyalty-reward",
										getClassNameVariant(data.length as number)
									])}
								>
									{loyaltyPointReward && (
										<>
											{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
												<CustomLoyaltyPointsV2>
													{loyaltyPointCrossout && (
														<CrossedOutText>
															Earn <CrownIconV2 height={"0.9em"} />
															{Number(loyaltyPointCrossout)?.toLocaleString(
																"en-US"
															)}
														</CrossedOutText>
													)}
													<LoyaltyValue>
														Earn <CrownIconV2 height={"1.1em"} />
														{loyaltyPointReward?.toLocaleString("en-US")}
													</LoyaltyValue>
													{/*
														{isPoisActive && (
															<CardFinalMessage
																color="#FBBD05"
																style={{ fontSize: "0.8em" }}
															>
																Contribute to Poi’s Bounty
															</CardFinalMessage>
														)}
													*/}
												</CustomLoyaltyPointsV2>
											) : (
												<LoyaltyPoints>
													<div>
														Earn <CrownIcon width={16} />
														{loyaltyPointReward?.toLocaleString("en-US")}
													</div>
													{/*
														{isPoisActive && (
															<CardFinalMessage color="#FBBD05">
																Contribute to Poi’s Bounty
															</CardFinalMessage>
														)}
													*/}
												</LoyaltyPoints>
											)}
										</>
									)}
									<Button
										style={{ fontSize: "1em", height: "3.2em" }}
										onClick={() => {
											onStickyAction(id, rewardId, price);
										}}
									>
										{price} USD
									</Button>
								</Footer>
							</OfferItem>
						);
					}
				)}
		</OffersStyled>
	);
};
